import React from 'react';

const ViewUserModal = ({ isOpen, onClose, user }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">User Details</h2>
        </div>
        {/* Content */}
        <div className="px-6 py-4">
          <div className="space-y-4">
            {/* Basic Information */}
            <div>
              <h3 className="text-sm font-medium text-gray-700 mb-3">User Information</h3>
              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-500">Employee Code</label>
                  <p className="text-sm text-gray-900">{user.ECode}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Name</label>
                  <p className="text-sm text-gray-900">{user.Name}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Grade</label>
                  <p className="text-sm text-gray-900">{user.Grade}</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Designation</label>
                  <p className="text-sm text-gray-900">{user.Designation}</p>
                </div>

                {/* <div>
                  <label className="block text-sm font-medium text-gray-500">Role</label>
                  <p className="text-sm text-gray-900">{user.Role}</p>
                </div> */}

                <div>
                  <label className="block text-sm font-medium text-gray-500">View Access</label>
                  <p className="text-sm text-gray-900">
                    {user.ReportingManagerName || '-'}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Phone Number</label>
                  <p className="text-sm text-gray-900">
                    {user.PhoneNumber || 'Not provided'}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Division</label>
                  <p className="text-sm text-gray-900">
                    {user.Division || '-'}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Zone</label>
                  <p className="text-sm text-gray-900">
                    {user.Zone || '-'}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-500">Cluster</label>
                  <p className="text-sm text-gray-900">
                    {user.Cluster ||  '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewUserModal;